import { Link } from '../../routes'
import classNames from 'classnames/bind'

import HeaderNavigation from './HeaderNavigation'
import UserData from './UserData'
import { withI18next } from '../../lib/withI18next'
import { Button } from '../uiLib'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      burgerMenuShown: false
    }
    this.toggleBurgerMenu = this.toggleBurgerMenu.bind(this)
  }

  toggleBurgerMenu() {
    this.setState({ burgerMenuShown: !this.state.burgerMenuShown })
  }

  render () {
    const { user, t, isAuthenticated, cart } = this.props
    const { burgerMenuShown } = this.state
    return (
      <div className="ma-header">
        <nav className="navbar is-transparent ma-navigation">
          <div className="navbar-brand">
            <Link route="/">
              <a className="navbar-item ma-logo">
                <img src="/static/images/mazda_logo.png" />
              </a>
            </Link>
            <div
              className={classNames({
                'navbar-burger': true,
                'burger': true,
                'is-active': burgerMenuShown
              })}
              onClick={this.toggleBurgerMenu}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            className={classNames({
              'navbar-menu ma-navigation-menu': true,
              'is-active': burgerMenuShown
            })}
          >
            <HeaderNavigation />
          </div>
        </nav>
        <div className="ma-sub-navigation">
          <div className="navbar-end">
            { cart.items.length > 0 ? (
              <div className="navbar-item ma-user-control">
                <Link route="/cart"><a className="navbar-item ma-shoppingcart">
                  <span className="icon">
                    <i className="mdi mdi-cart" aria-hidden="true" />
                  </span>
                  <span>{ cart.items.length } {t('common:items')}</span>
                </a></Link>
              </div>
            ) : null }
            {
              user && isAuthenticated ? (
                <div className="navbar-item ma-user-control">
                  <UserData
                    name={user.username}
                    isAdmin={user.is_admin}
                  >
                    <Link route="/account">
                      <a className="dropdown-item">
                        <span className="icon is-small">
                          <i className="mdi mdi-settings-outline" aria-hidden="true" />
                        </span>
                        <span>Account</span>
                      </a>
                    </Link>
                  </UserData>
                </div>
              ) : (
                <div className="navbar-item ma-login">
                  <div className="field is-grouped">
                    <div className="control">
                      <Link route="/login">
                        <Button className="is-default login">
                          {t('common:navigation_menu-login')}
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

export default withI18next(['common'])(Header)




// WEBPACK FOOTER //
// ./components/Header/index.js